import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { timer } from 'rxjs';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
  data:any;
}

@Component({
  selector: 'app-numpad',
  templateUrl: './numpad.component.html',
  styleUrls: ['./numpad.component.css'],
})
export class NumpadComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  data:any;
  result: any = { result: false, RtnItem: {} };
  inputValue = '';
  MaxDigit = 4;
  DecimalAllow = true;
  oldValueShow = false;
  ol_value: string;
  AllowBlank: boolean;
  type = 'text'
  view_Type = 0;
  old_value_text = '';
  @ViewChild('num') num: ElementRef;

  constructor(public dialogService: DialogService) {
    super(dialogService);
   }

  ngOnInit() {
    const abc: string = String(this.data.value);
    this.inputValue = abc == '0' ? '' : abc;
    if (this.data.MaxDigit) {
      this.MaxDigit = Number(this.data.MaxDigit);
    }
    if (this.data.DecimalAllow) {
      this.DecimalAllow = Boolean(this.data.DecimalAllow);
    }
    if (this.data.AllowBlank) {
      this.AllowBlank = Boolean(this.data.AllowBlank);
    }
    if (this.data.CShow) {
      this.oldValueShow = Boolean(this.data.CShow);
      this.ol_value = this.inputValue;
      this.inputValue = '';
    }
    if (this.data.type) {
      this.type = this.data.type;
    }
    if (this.title == 'CHANGE PRICE') {
      this.view_Type = 5;
      this.old_value_text = 'Original Price';
    } else {
      this.old_value_text = 'Current Value';
    }
    this.focusto();
  }

  enterOk() {
    if (!this.AllowBlank) {
      if (this.inputValue == '' || Number(this.inputValue) == 0) {
        return;
      }
    }

    this.result.result = true;
    this.result.RtnItem = this.inputValue;
    this.close();
  }

  keydown(e) {
    if (e.keyCode == 8 && e.which == 8) {
      // this.keypress('<')
    } else if (e.keyCode >= 96 && e.keyCode <= 105) {
      // this.keypress(e.key)
    } else if (e.keyCode >= 48 && e.keyCode <= 57) {
      // this.keypress(e.key)
    } else if (e.keyCode == 110 || e.keyCode == 190) {
      this.keypress(e.key);
    } else if (e.keyCode == 13 && e.which == 13) {
      this.enterOk();
    }
    this.focusto();
  }

  focusto() {
    document.getElementById('num').focus();
  }

  selectAll() {
    const source = timer(200, 1000);
    const sub = source.subscribe(res => {
      const input: any = document.getElementById('num');
      input.focus();
      input.select();
      sub.unsubscribe();
    });
  }

  selection() {
    const input: any = document.getElementById('num');
  }

  keypress(e) {
    this.focusto();
    if (e == '.') {
      if (this.inputValue == '') {
        this.inputValue = '0';
      } else {
        if (this.inputValue.indexOf('.') > -1) {
          return;
        }
      }
    }
    if (e == '<') {
      this.inputValue = this.inputValue.slice(0, -1);
    } else {
      if (this.DecimalAllow) {
        if (this.inputValue.length < this.MaxDigit) {
          this.inputValue = this.inputValue + e;
        }
      } else {
        if (this.inputValue.length < this.MaxDigit) {
          this.inputValue = this.inputValue + e;
        }
      }

    }
  }

}
